import {Messenger, MessengerProps} from "./messenger";
import CsInstance from "../state/CsInstance";
import createMessengerHandlers from "./messengerHandlers";

export class Manager {
	private _messenger?: Messenger;

	private _csInstance: CsInstance;

	constructor(csInstance: CsInstance) {
		this._csInstance = csInstance;
	}

	getOrCreateMessenger() {
		// TODO check if current messenger is dead
		if (!this._messenger) {
			this._csInstance.theaterStore.messengerLoading = true;

			const messengerProps: MessengerProps = {
				messengerHandlers: createMessengerHandlers({
					csInstance: this._csInstance,
				}),
				onConsoleLogLine: (line) => {
					this._csInstance.theaterStore.addLine(line);
				},
				featureFlagStore: this._csInstance.featureFlagStore,
				onTicketResponse: async (response) => {
					// CheerpJ will let you continue to run the code
					// don't allow that
					if (response.status === "Error") {
						// Put in the console as an error.
						// TODO Unfortunately this overwrites future normal console logs; mobx
						// stores need to be refactored to handle this better.
						this._csInstance.compileStore.setErrorStatusAndMessage(
							response.result
						);

						// Pause ticker and disable pause/play buttons but allow reset button
						this._csInstance.theaterStore.isRunning = false;
						this.getOrCreateMessenger().pauseTheater();
						this._csInstance.theaterStore.runtimeErrorOccurred = true;

						return;
					}
				},
			};
			this._messenger = new Messenger(messengerProps);
		}
		return this._messenger;
	}

	prepNewVersionedJarMessenger(
		jarData: Uint8Array,
		version: number,
		javaConsoleLogCallback: (
			input: string
		) => void = this._csInstance.defaultConsoleLogCallback.bind(
			this._csInstance
		),
		studentInputCallback: (
			input: number
		) => void = this._csInstance.defaultConsoleInputCallback.bind(
			this._csInstance
		)
	) {
		this.getOrCreateMessenger().loadCode(jarData, version);
	}

	isMessengerReady() {
		return false;
	}

	cleanupMessenger() {
		if (this._messenger) {
			this._messenger.destroyWorker();
			this._messenger = undefined;
		}
	}
}
